
import React, { ReactNode } from 'react';

interface SafeProviderProps {
  children: ReactNode;
  fallback?: ReactNode;
  name: string;
}

export const SafeProvider: React.FC<SafeProviderProps> = ({ 
  children, 
  fallback = null, 
  name 
}) => {
  try {
    return <>{children}</>;
  } catch (error) {
    console.error(`🚨 SafeProvider: ${name} failed to render:`, {
      error: error?.message || 'Unknown error',
      stack: error?.stack,
      timestamp: new Date().toISOString(),
    });
    
    return <>{fallback}</>;
  }
};

export default SafeProvider;
